import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useLocation } from "react-router-dom";
import { v4 as uuid } from "uuid";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import {
    Box,
    Button,
    ButtonGroup,
    Grid,
    IconButton,
    Modal,
    TextField,
    Typography,
} from "@mui/material";

import tableIcons from "../tableFormatting/tableIcons";



const NanoProgress = ({ data }) => {

    const [topics, setTopics] = useState([]);
    const [selectedDataSet, setSelectedDataSet] = useState(1);
    const [studentData, setStudentData] = useState([])

useEffect(() => {

    const reformattedData = [];
    const avatarData = [];

    const userData = [
        {
            name: "Annette B",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Andreas R",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Bertta Y",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Dylan C",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Inkeri L",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Jani T",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Jaana P",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Leena O",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Milla M",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Pekka H",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Selene A",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Ryan P",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Stuart W",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Tiia T",
            value: Math.floor(Math.random() * 100) + 1, 
        },
        {
            name: "Tiia I",
            value: Math.floor(Math.random() * 100) + 1, 
        },
    ]



    userData.map((d,i) => {
        function stringToColor() {
        // var userName = d.name;

            let hash = 0;
            let i;
            if(d.name != undefined) {
            /* eslint-disable no-bitwise */
            for (i = 0; i < d.name.length; i += 1) {
              hash = d.name.charCodeAt(i) + ((hash << 5) - hash);
            }
          
            let color = '#';
          
            for (i = 0; i < 3; i += 1) {
              const value = (hash >> (i * 8)) & 0xff;
              color += `00${value.toString(36)}`.slice(-2);
            }
            /* eslint-enable no-bitwise */
        //   console.log(color)
            return color;
            } 
          }
          
          function stringAvatar() {
            if(d.name != undefined) {
            return {
              sx: {
                bgcolor: stringToColor(d.name),
              },
              children: `${d.name.split(' ')[0][0]}${d.name.split(' ')[1][0]}`,
            };
          } 
          }
// stringToColor()
stringAvatar(d.name)
avatarData.push(stringAvatar(d.name))

    })
console.log(avatarData)

userData.map((d,i) => {
    reformattedData.push({
        name: d.name,
        value: d.value,
        avatarTitle: avatarData[i].children,
        avatarColor: avatarData[i].sx.bgcolor
    })
})
    
    setStudentData(reformattedData)

},[selectedDataSet])

    console.log(studentData)

    useEffect(() => {
        const names = [];

        data.map((d,i) => {
            // console.log(d.name)
            names.push({category: d.name, value: Math.floor(Math.random() * 100) + 1, full: 100})
            d.children.map((x,y) => {
                names.push({category: x.name, value: Math.floor(Math.random() * 100) + 1, full: 100})
                x.children.map((a,b) => {
                    names.push({category: a.name, value: Math.floor(Math.random() * 100) + 1, full: 100})
                })
            })
        })
        // console.log(names)
        setTopics(names)
    },[])
    console.log(topics)

    useLayoutEffect(() => {



        var chart = am4core.create("progressdiv", am4charts.RadarChart);

        chart.data = topics;

        // Add data
        // chart.data = [{
        //   "category": "Research",
        //   "value": 80,
        //   "full": 100
        // }, {
        //   "category": "Marketing",
        //   "value": 35,
        //   "full": 100
        // }, {
        //   "category": "Distribution",
        //   "value": 92,
        //   "full": 100
        // }, {
        //   "category": "Human Resources",
        //   "value": 68,
        //   "full": 100
        // }];
        
        
        // Make chart not full circle
        chart.startAngle = -90;
        chart.endAngle = 180;
        chart.innerRadius = am4core.percent(20);
        
        // Set number format
        chart.numberFormatter.numberFormat = "#.#'%'";
        
        // Create axes
        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.grid.template.strokeOpacity = 0;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.fontWeight = 500;
        categoryAxis.renderer.labels.template.adapter.add("fill", function(fill, target) {
          return (target.dataItem.index >= 0) ? chart.colors.getIndex(target.dataItem.index) : fill;
        });
        categoryAxis.renderer.minGridDistance = 10;
        
        var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeOpacity = 0;
        valueAxis.min = 0;
        valueAxis.max = 100;
        valueAxis.strictMinMax = true;
        
        // Create series
        var series1 = chart.series.push(new am4charts.RadarColumnSeries());
        series1.dataFields.valueX = "full";
        series1.dataFields.categoryY = "category";
        series1.clustered = false;
        series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
        series1.columns.template.fillOpacity = 0.08;
        series1.columns.template.cornerRadiusTopLeft = 20;
        series1.columns.template.strokeWidth = 0;
        series1.columns.template.radarColumn.cornerRadius = 20;
        
        var series2 = chart.series.push(new am4charts.RadarColumnSeries());
        series2.dataFields.valueX = "value";
        series2.dataFields.categoryY = "category";
        series2.clustered = false;
        series2.columns.template.strokeWidth = 0;
        series2.columns.template.tooltipText = "{category}: [bold]{value}[/]";
        series2.columns.template.radarColumn.cornerRadius = 20;
        
        series2.columns.template.adapter.add("fill", function(fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });
        
        // Add cursor
        chart.cursor = new am4charts.RadarCursor();

    }, [topics, selectedDataSet])
  






    useLayoutEffect(() => {

        var chart = am4core.create("progressbardiv", am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
        
        chart.paddingRight = 40;
        
        chart.data = studentData;
        // chart.data = [{
        //     "name": "Monica",
        //     "steps": 45688,
        //     "href": "https://www.amcharts.com/wp-content/uploads/2019/04/monica.jpg"
        // }, {
        //     "name": "Joey",
        //     "steps": 35781,
        //     "href": "https://www.amcharts.com/wp-content/uploads/2019/04/joey.jpg"
        // }, {
        //     "name": "Ross",
        //     "steps": 25464,
        //     "href": "https://www.amcharts.com/wp-content/uploads/2019/04/ross.jpg"
        // }, {
        //     "name": "Phoebe",
        //     "steps": 18788,
        //     "href": "https://www.amcharts.com/wp-content/uploads/2019/04/phoebe.jpg"
        // }, {
        //     "name": "Rachel",
        //     "steps": 15465,
        //     "href": "https://www.amcharts.com/wp-content/uploads/2019/04/rachel.jpg"
        // }, {
        //     "name": "Chandler",
        //     "steps": 11561,
        //     "href": "https://www.amcharts.com/wp-content/uploads/2019/04/chandler.jpg"
        // }];
        
        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.strokeOpacity = 0;
        categoryAxis.renderer.minGridDistance = 10;
        categoryAxis.renderer.labels.template.dx = -40;
        categoryAxis.renderer.minWidth = 120;
        categoryAxis.renderer.tooltip.dx = -40;
        
        var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.inside = true;
        valueAxis.renderer.labels.template.fillOpacity = 0.3;
        valueAxis.renderer.grid.template.strokeOpacity = 0;
        valueAxis.min = 0;
        valueAxis.cursorTooltipEnabled = false;
        valueAxis.renderer.baseGrid.strokeOpacity = 0;
        valueAxis.renderer.labels.template.dy = 20;
        
        var series = chart.series.push(new am4charts.ColumnSeries);
        series.dataFields.valueX = "value";
        series.dataFields.categoryY = "name";
        series.tooltipText = "{valueX.value}";
        series.tooltip.pointerOrientation = "vertical";
        series.tooltip.dy = - 30;
        series.columnsContainer.zIndex = 100;
        
        var columnTemplate = series.columns.template;
        columnTemplate.height = am4core.percent(50);
        columnTemplate.maxHeight = 50;
        columnTemplate.column.cornerRadius(60, 10, 60, 10);
        columnTemplate.strokeOpacity = 0;
        
        series.heatRules.push({ target: columnTemplate, property: "fill", dataField: "valueX", min: am4core.color("#e5dc36"), max: am4core.color("#5faa46") });
        series.mainContainer.mask = undefined;
        
        var cursor = new am4charts.XYCursor();
        chart.cursor = cursor;
        cursor.lineX.disabled = true;
        cursor.lineY.disabled = true;
        cursor.behavior = "none";
        
        // var bullet = columnTemplate.createChild(am4charts.CircleBullet);
        // bullet.circle.radius = 30;
        // // bullet.fill = "{avatarColor}"
        // bullet.valign = "middle";
        // bullet.align = "left";
        // bullet.isMeasured = true;
        // bullet.interactionsEnabled = false;
        // bullet.horizontalCenter = "right";
        // bullet.interactionsEnabled = false;
        // bullet.text = "{value}";

    
        
        
        
        
        // var labelBullet = bullet.push(new am4charts.LabelBullet());
        // labelBullet.label.text = "{avatarTitle}";
        // labelBullet.fill = "{avatarColor}"

        


        var bullet = columnTemplate.createChild(am4charts.CircleBullet);
        bullet.circle.radius = 15;
        bullet.valign = "middle";
        bullet.align = "left";
        bullet.isMeasured = true;
        bullet.interactionsEnabled = false;
        bullet.horizontalCenter = "right";
        bullet.interactionsEnabled = false;


        var labelBullet = columnTemplate.createChild(am4charts.LabelBullet);
        labelBullet.label.text = "{avatarTitle}\n{value}%";
        labelBullet.fill = "{avatarColor}"

        // labelBullet.label.dy = -20;



        // var circle = bullet.createChild(am4core.LabelBullet);
        // // circle.width = 60;
        // // circle.height = 60;
        // // circle.horizontalCenter = "middle";
        // // circle.verticalCenter = "middle";
        // circle.label.text = "{avatarTitle}"
        // image.propertyFields.href = "href";
        
        // image.adapter.add("mask", function (mask, target) {
        //     var circleBullet = target.parent;
        //     return circleBullet.circle;
        // })


        var hoverState = bullet.states.create("hover");
        var outlineCircle = bullet.createChild(am4core.Circle);
        outlineCircle.adapter.add("radius", function (radius, target) {
            var circleBullet = target.parent;
            return circleBullet.circle.pixelRadius + 10;
        })
        
        var previousBullet;
        chart.cursor.events.on("cursorpositionchanged", function (event) {
            var dataItem = series.tooltipDataItem;
        
            if (dataItem.column) {
                var bullet = dataItem.column.children.getIndex(1);
        
                if (previousBullet && previousBullet != bullet) {
                    previousBullet.isHover = false;
                }
        
                if (previousBullet != bullet) {
        
                    var hs = bullet.states.getKey("hover");
                    hs.properties.dx = dataItem.column.pixelWidth;
                    bullet.isHover = true;
        
                    previousBullet = bullet;
                }
            }
        })
        
        

    }, [topics, selectedDataSet])


return (
   <div style={{ width: "90vw" }}>


<Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justify="center"
                //   style={{ minHeight: '100vh' }}
                  >
    <h3>Completion Status</h3>

    <ButtonGroup disableElevation variant="contained" color="primary">
    <Button variant={selectedDataSet === 1 ? "contained" : "outlined"} onClick={()=>setSelectedDataSet(1)}>Topic progress</Button>
        <Button variant={selectedDataSet === 2 ? "contained" : "outlined"}  onClick={()=>setSelectedDataSet(2)}>Student progress</Button>
    </ButtonGroup>
    </Grid>
{selectedDataSet == 1 ? (
  <Grid item xs={12}>
  <div className="progressdiv" id="progressdiv" style={{ width: "100%", height: "60vh" }} />
  {/* <div className="progressdiv" id="progressdiv" style={{ width: "90vw", height: "60vh", pageBreakAfter: "always" }} /> */}

  </Grid>
) : (
    <Grid item xs={12}>
    <div className="progressbardiv" id="progressbardiv" style={{ width: "100%", height: "60vh" }}/>
    {/* <div className="progressbardiv" id="progressbardiv" style={{ width: "90vw", height: "60vh", pageBreakAfter: "always" }} /> */}
  
    </Grid>
)}



       

   </div>
)
};


export default NanoProgress